<template>
  <app-layout>
    <div class="page-faq">
      <v-card class="faq-container">
        <v-card-title
          class="text-center justify-center py-32 flex-column bg-navy color-white"
        >
          <h2 class="heading-1 break-normal">
            {{appConfig === "avm" ? $t("faqs.avm_discover") : $t("faqs.ebm.avm_discover")}}
          </h2>
          <p class="heading-2-small hidden md:block">
            {{ appConfig === "avm" ? $t("faqs.find_flight") : $t("faqs.ebm.find_flight") }}
          </p>
        </v-card-title>

        <div class="hidden md:block">
          <v-tabs
            :hide-slider="true"
            background-color="#001d38"
            centered
            v-model="selectedTab"
            dark
          >
            <v-tab
              v-for="tab in tabsTitle"
              class="tab bg-brown-grey heavy-label color-white"
              active-class="bg-white color-black"
              :key="tab.id"
            >
              {{ tab.text }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="selectedTab">
            <v-tab-item
              class="max-width mx-auto mb-15"
              v-for="t in tabsTitle"
              :key="t.id"
            >
              <v-card
                class="mt-15"
                flat
                v-for="(tab, key, index) in tabsContent[selectedTab]"
                :key="index"
              >
                <v-card-title class="heading-3">{{ $t(tab.title) }}</v-card-title>
                <v-card-text>
                  <p class="paragraph-r-16 color-black" v-html="$t(tab.paragraph)"></p>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </div>

        <template>
          <div class="block md:hidden panels pt-6">
            <v-col class="d-flex" cols="12" sm="6">
              <v-select
                class="select paragraph-h-18"
                append-icon="expand_more"
                dense
                outlined
                :items="tabsTitle"
                item-value="id"
                v-model="selectedTab"
              ></v-select>
            </v-col>
            <v-expansion-panels accordion flat>
              <v-expansion-panel
                v-for="(tab, key, index) in tabsContent[selectedTab]"
                :key="index"
              >
                <v-expansion-panel-header class="paragraph-h-18">
                  {{ $t(tab.title) }}
                  <template v-slot:actions>
                    <v-icon color="primary">add</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  {{ $t(tab.paragraph) }}
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </template>
      </v-card>
      <app-banner-newsletter background="/img/background-image-newsletter.jpg"></app-banner-newsletter>
    </div>
  </app-layout>
</template>
<script>
import store from "../store";
import handleAppBarItems from "../utils/handleAppBarItems";

export default {
  data() {
    return {
      selectedTab: 0,
      appConfig: window.appConfig,
      tabsAvmTitle: [
        {
          id: 0,
          text: this.$t("faqs.about_avm")
        },
        {
          id: 1,
          text: this.$t("faqs.bookings")
        },
        {
          id: 2,
          text: this.$t("faqs.confirm_reservation")
        },
        {
          id: 3,
          text: this.$t("faqs.gift_coupon")
        },
        {
          id: 4,
          text: this.$t("faqs.cancellations")
        }
      ],
      tabsAvmContent: [
        [
          {
            title: "faqs.question_1",
            paragraph:
              "faqs.answer_1"
          },
          {
            title: "faqs.question_2",
            paragraph:
              "faqs.answer_2"
          },
          {
            title: "faqs.question_3",
            paragraph:
              "faqs.answer_3"
          },
          {
            title: "faqs.question_4",
            paragraph:
              "faqs.answer_4"
          }
        ],
        [
          {
            title: "faqs.question_5",
            paragraph:
              "faqs.answer_5"
          },
          {
            title: "faqs.question_6",
            paragraph:
              "faqs.answer_6"
          },
          {
            title: "faqs.question_7",
            paragraph:
              "faqs.answer_7"
          },
          {
            title: "faqs.question_8",
            paragraph:
              "faqs.answer_8"
          },
          {
            title: "faqs.question_9",
            paragraph:
              "faqs.answer_9"
          },
        ],
        [
          {
            title: "faqs.question_10",
            paragraph:
              "faqs.answer_10"
          },
          {
            title: "faqs.question_11",
            paragraph:
              "faqs.answer_11"
          },
          {
            title: "faqs.question_12",
            paragraph:
              "faqs.answer_12"
          },
        ],
        [
          {
            title: "faqs.question_13",
            paragraph:
              "faqs.answer_13"
          },
          {
            title: "faqs.question_14",
            paragraph: "faqs.answer_14"
          },
          {
            title: "faqs.question_15",
            paragraph: "faqs.answer_15"
          },
          {
            title: "faqs.question_16",
            paragraph: "faqs.answer_16"
          },
          {
            title: "faqs.question_17",
            paragraph: "faqs.answer_17"
          }
        ],
        [
          {
            title: "faqs.question_18",
            paragraph: "faqs.answer_18"
          },
          {
            title: "faqs.question_19",
            paragraph: "faqs.answer_19"
          },
          {
            title: 'faqs.question_20',
            paragraph: "faqs.answer_20"
          },
          {
            title: 'faqs.question_21',
            paragraph: "faqs.answer_21"
          },
        ]
      ],
      tabsEbmTitle: [
        {
          id: 0,
          text: this.$t("faqs.ebm.about_avm")
        },
        {
          id: 1,
          text: this.$t("faqs.ebm.bookings")
        },
        {
          id: 2,
          text: this.$t("faqs.ebm.process_reservation")
        },
        {
          id: 3,
          text: this.$t("faqs.confirm_reservation")
        },
        {
          id: 4,
          text: this.$t("faqs.ebm.cancellations")
        }
      ],
      tabsEbmContent: [
        [
          {
            title: "faqs.ebm.question_1",
            paragraph:
              "faqs.ebm.answer_1"
          },
          {
            title: "faqs.ebm.question_2",
            paragraph:
              "faqs.ebm.answer_2"
          },
          {
            title: "faqs.ebm.question_3",
            paragraph:
              "faqs.ebm.answer_3"
          },
          {
            title: "faqs.ebm.question_4",
            paragraph:
              "faqs.ebm.answer_4"
          },
          {
            title: "faqs.ebm.question_5",
            paragraph:
              "faqs.ebm.answer_5"
          },
        ],
        [
        {
            title: "faqs.ebm.question_6",
            paragraph:
              "faqs.ebm.answer_6"
          },
          {
            title: "faqs.ebm.question_7",
            paragraph:
              "faqs.ebm.answer_7"
          },
          {
            title: "faqs.ebm.question_8",
            paragraph:
              "faqs.ebm.answer_8"
          },
          {
            title: "faqs.ebm.question_9",
            paragraph:
              "faqs.ebm.answer_9"
          },
        ],
        [
        {
            title: "faqs.ebm.question_10",
            paragraph:
              "faqs.ebm.answer_10"
          },
          {
            title: "faqs.ebm.question_11",
            paragraph:
              "faqs.ebm.answer_11"
          },
          {
            title: "faqs.ebm.question_12",
            paragraph:
              "faqs.ebm.answer_12"
          },
          {
            title: "faqs.ebm.question_13",
            paragraph:
              "faqs.ebm.answer_13"
          }
        ],
        [
          {
              title: "faqs.ebm.question_14",
              paragraph: "faqs.ebm.answer_14"
            },
            {
              title: "faqs.ebm.question_15",
              paragraph: "faqs.ebm.answer_15"
            },
            {
              title: "faqs.ebm.question_16",
              paragraph: "faqs.ebm.answer_16"
            },
        ],
        [
          {
            title: "faqs.ebm.question_17",
            paragraph: "faqs.ebm.answer_17"
          },
          {
            title: "faqs.ebm.question_18",
            paragraph: "faqs.ebm.answer_18"
          },
          {
            title: "faqs.ebm.question_19",
            paragraph: "faqs.ebm.answer_19"
          }
        ]
      ]
    };
  },
  computed: {
    tabsTitle(){
      return this.appConfig === "avm" ? this.tabsAvmTitle : this.tabsEbmTitle;
    },
    tabsContent() {
      return this.appConfig === "avm" ? this.tabsAvmContent : this.tabsEbmContent;
    }
  },
  created() {
    this.$eventHub.$emit(
      "update-header",
      handleAppBarItems.call(this, router.currentRoute)
    );
    const tabId = this.$route.params.tab;
    if (tabId !== undefined) {
      this.selectedTab = parseInt(tabId);
    }
    this.$eventHub.$emit(
      "update-header",
      handleAppBarItems.call(this, this.$router.currentRoute)
    );
  }
};
</script>

<style lang="scss" scoped>
.page-faq {
  .faq-container {
    border: none;
    border-radius: 0;
    box-shadow: none;

    .py-32 {
      @media screen and (max-width: 768px) {
        padding-top: 4rem;
        padding-bottom: 4rem;
      }

      .heading-1 {
        line-height: 95px;
        @media screen and (max-width: 768px) {
          line-height: 40px;
        }
      }
    }

    .tab {
      border-top-right-radius: 7px;
      border-top-left-radius: 7px;
      text-transform: unset;
      margin-right: 15px;
      min-width: 300px;
      letter-spacing: 0;
    }

    .panels {
      padding-bottom: 20px;
      .select {
        border-radius: 30px;
      }

      i {
        font-size: 40px;
      }
    }
  }
}
</style>
